import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { INSIGHTS } from "../lib/constants";

export default function Insights() {
  const [featured, ...rest] = INSIGHTS;
  return (
    <div data-testid="page-insights">
      <section className="bg-white border-b border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-24 pb-16">
          <div className="overline rule-teal">Insights</div>
          <h1 className="font-display text-5xl sm:text-6xl mt-6 leading-[1.02] text-[#0B2E5C] max-w-3xl">
            Notes from the engagement room.
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-[#475569] leading-relaxed font-light">
            Practical commentary on audit, IFRS, tax and the Somali market —
            written by the partners and managers who do the work.
          </p>
        </div>
      </section>

      <section className="bg-[#F8FAFC]" data-testid="insights-featured">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
          <article
            data-testid={`insight-featured-${featured.slug}`}
            className="bg-white border border-[#E2E8F0] grid grid-cols-1 lg:grid-cols-12 overflow-hidden card-lift"
          >
            <div
              className="lg:col-span-6 bg-cover bg-center min-h-[320px]"
              style={{
                backgroundImage:
                  "url(https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxmaW5hbmNpYWwlMjBkb2N1bWVudHMlMjBhY2NvdW50aW5nfGVufDB8fHx8MTc3ODkyMDU3N3ww&ixlib=rb-4.1.0&q=85)",
              }}
            />
            <div className="lg:col-span-6 p-10 md:p-14 flex flex-col justify-center">
              <div className="overline">{featured.category} · Featured</div>
              <h2 className="font-display text-3xl sm:text-4xl text-[#0B2E5C] mt-4 leading-tight">
                {featured.title}
              </h2>
              <p className="mt-5 text-[#475569] font-light leading-relaxed">
                {featured.excerpt}
              </p>
              <div className="mt-8 flex items-center justify-between text-sm text-[#475569]">
                <span>{featured.date}</span>
                <span>{featured.readTime}</span>
              </div>
              <Link
                to="/contact"
                data-testid="insight-featured-cta"
                className="link-underline mt-6 text-[#0B2E5C] font-medium inline-flex items-center"
              >
                Read the full note <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </article>
        </div>
      </section>

      <section className="bg-white border-y border-[#E2E8F0]" data-testid="insights-grid">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <div className="overline rule-teal">More articles</div>
          <h2 className="font-display text-4xl mt-4 leading-tight text-[#0B2E5C]">
            Recent commentary.
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px mt-14 bg-[#E2E8F0] border border-[#E2E8F0]">
            {rest.map((a) => (
              <article
                key={a.slug}
                data-testid={`insights-card-${a.slug}`}
                className="bg-white p-8 card-lift"
              >
                <div className="overline">{a.category}</div>
                <h3 className="font-display text-2xl text-[#0B2E5C] mt-4 leading-tight">
                  {a.title}
                </h3>
                <p className="mt-4 text-[#475569] font-light leading-relaxed text-sm">
                  {a.excerpt}
                </p>
                <div className="mt-6 flex items-center justify-between text-xs text-[#475569]">
                  <span>{a.date}</span>
                  <span>{a.readTime}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#F1F5F9]" data-testid="insights-cta">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 text-center">
          <div className="overline rule-teal mx-auto">Stay informed</div>
          <h2 className="font-display text-4xl mt-4 leading-tight text-[#0B2E5C]">
            Quarterly insights, delivered.
          </h2>
          <p className="mt-4 text-[#475569] font-light text-lg max-w-xl mx-auto">
            Subscribe via the form in our footer to receive curated commentary on
            audit, IFRS and Somali market developments.
          </p>
        </div>
      </section>
    </div>
  );
}
